import {FETCHED_BALANCE} from '../../types';
import {web3,ids} from '../../../config'
var Web3 = require("web3");

export function getETHBalanceDispatch(){
  return function(dispatch,getState){
    getETHBalance(dispatch,getState())
  }
}

export async function getETHBalance(dispatch,state) {
  for(let address of Object.keys(state.passport.wallet.eth)){
    const mainnet_url = `https://mainnet.infura.io/v3/${ids[Math.floor(Math.random() * ids.length)]}`;
    const web3 = new Web3(new Web3.providers.HttpProvider(mainnet_url));

    let result = await web3.eth.getBalance(address)
    if(result){
      dispatch({
        type: FETCHED_BALANCE,
        payload: {balance:web3.utils.fromWei(result),asset:'eth',address}
      });
    }
  }
}
